/* @ngInject */
export default function (APIService) {
	return APIService.service('permissions/users');
};


// WEBPACK FOOTER //
// ./src/js/factories/permissions/users/index.js